import React from "react";
import FloatingActionContainer from "../../../shared/FloatingActionContainer";
import InquiryButton from "./InquiryButton";
import { handleApply } from "../../utils/handleApply";

// resourceType（jobs / projects）をボタン用のtype（job / project）に変換するためのマッピング
const inquiryButtonTypeMap = {
  jobs: "job",
  projects: "project",
};

// 画面右下に表示される、問い合わせ用のフローティングボタン
const InquiryFloatingButton = ({
  isMobile,
  resourceType,
  resourceId,
  csrfToken,
}) => {
  // ボタン表示用のtypeを取得
  const buttonType = inquiryButtonTypeMap[resourceType];

  // 想定外のtypeは描画しない
  if (!buttonType) return null;

  // 問い合わせ処理
  const handleClick = () => {
    handleApply({
      type: resourceType,
      id: resourceId,
      csrfToken,
    });
  };

  return (
    <FloatingActionContainer>
      <InquiryButton
        isMobile={isMobile}
        onClick={handleClick}
        label="詳細を聞きたい"
        tooltip="運営局に問い合わせメールが送信されます"
        type={buttonType}
      />
    </FloatingActionContainer>
  );
};

export default InquiryFloatingButton;
